import { InjectionToken } from '@angular/core';

/** Default localStorage key the bearer token is stored under. */
export const DEFAULT_FEEDBACK_API_TOKEN_STORAGE_KEY = 'id_token_delegate_feedback-api';

/**
 * The localStorage key the Feedback API bearer token is read from by the
 * auth interceptor / token store. Override via {@link provideFeedbackApi}.
 */
export const FEEDBACK_API_TOKEN_STORAGE_KEY = new InjectionToken<string>(
  'FEEDBACK_API_TOKEN_STORAGE_KEY',
  { factory: () => DEFAULT_FEEDBACK_API_TOKEN_STORAGE_KEY },
);
